import { useContext } from "react";

import { Group, Stack, StackProps } from "@mantine/core";

import { IconReportMedical } from "@tabler/icons-react";

import { ProfileContext } from "@/contexts/profile";
import { usePractitionerPermissions } from "@/permission/hooks/usePractitionerPermissions";

import { NoDataContainer } from "../../NoDataContainer";

type ProceduresTabNoDataProps = Omit<StackProps, "children"> & {
  open: () => void;
  isEncounterActive?: boolean;
  isAmendment?: boolean;
};

const ProceduresTabNoData = ({
  open,
  isEncounterActive = false,
  isAmendment = false,
  ...stackProps
}: ProceduresTabNoDataProps) => {
  const { isPatient } = useContext(ProfileContext);
  const { hasProviderOrScribeRole } = usePractitionerPermissions();
  const canAddProcedures = !isPatient && hasProviderOrScribeRole;

  return (
    <Stack gap="xs" {...stackProps}>
      <Group
        p="md"
        bg="white"
        justify="space-between"
        style={{ borderRadius: 8 }}
        bd="1px solid var(--mantine-color-cream-4)"
      >
        <NoDataContainer
          onAnchorClick={open}
          text="No procedures have been added."
          actionTestId="procedures-tab-no-data-add-button"
          hideAnchor={!canAddProcedures || (!isEncounterActive && !isAmendment)}
          icon={<IconReportMedical size={18} color="var(--mantine-color-gray-8)" />}
          linkText={(isEncounterActive || isAmendment) && canAddProcedures ? "Add Procedure" : ""}
        />
      </Group>
    </Stack>
  );
};

export default ProceduresTabNoData;
